export class Answers {
  Email: string;
  Q1: string;
  Q2: string;
  Q3: string;
  Answer1: string;
  Answer2: string;
  Answer3: string;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/Answers.ts